import React from 'react'
import * as qs from 'query-string';
import { connect } from 'react-redux'
import Login from './Login'
import VerifyEmail from './RegistrationForms/VerifyEmailAlertPanel'
import { logout, alreadyLogin, getLawyer } from '../actions/actionCreators'
import { history } from '../store'
import { withRouter } from 'react-router-dom'
import { LanguageContext, Translate } from '../helpers/language';
import { backendService } from '../services/backendService';
import { NotificationManager } from 'react-notifications';
import AppSidebar from './Layout/AppSidebar';
import RegistrationIntegrationPanel from './RegistrationForms/RegistrationIntegrationPanel';
import { elapsed } from './../services/defaults';

//import styles
import '../styles/layout.css'
import '../styles/login.css'
import '../styles/registration.css'
import '../styles/lisia-elements.css'
import '../styles/search.css'

class NavBar extends React.Component {

  constructor() {
    super()
    this.renderDashboard = this.renderDashboard.bind(this)
  }

  state = {
    visible: false,
    logged: false,
  }

  logout() {
    window.dataLayer.push({
      event: 'user_event',
      eventProps: {
        category: 'user_action',
        action: 'logout',
        label: 'User Logout',
        value: 'true'
    }
    });
    this.props.dispatch(logout())
    history.push('/login')
    this.toggleVisibility()
  }

  toggleVisibility() {
    this.setState({ visible: !this.state.visible })
  }

  componentWillMount() {
    const isLogged = JSON.parse(localStorage.getItem('user'))
    if (!isLogged) {
      this.setState({logged: true})
      this.props.history.push('/login')
    } else {
      this.props.dispatch(alreadyLogin())
    }
  }

  async componentDidMount() {
    if (this.props.auth && this.props.auth.user) 
    {      
      this.props.dispatch(getLawyer(this.props.auth.user.id)).then( async () => {
        const res = await backendService.get('/api/users/login/check');        
        if ( res && res.data && this.props.auth.user.is_verified && (this.props.auth.user.desired_plan_id === null || this.props.auth.user.desired_plan_id === undefined) ) {
          if (res.data && res.data.license !== undefined && !res.data.license)
            NotificationManager.warning(Translate(this.context, 'subscription_manage_alert_body'), Translate(this.context, 'subscription_expired'), 0);
          /*
          if (res.data && res.data.invoice_settings_ok !== undefined && !res.data.invoice_settings_ok)
            NotificationManager.warning(Translate(this.context, 'user_profile_invoice_settings_info'), Translate(this.context, 'user_profile_we_need_some_info'), 0);          
          */
        } 
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const isLogged = JSON.parse(localStorage.getItem('user'))
    if (!isLogged) {
      this.setState({logged: true})
      this.props.history.push('/login')
    }
  }

  renderVerify() {
    return (       
      <VerifyEmail />    
    )
  }

  RegistrationIntegrationPanel() {
    return (       
      <RegistrationIntegrationPanel />    
    )
  }

  renderDashboard() {    
    return (
      <AppSidebar content={this.props.children} />        
    )
  }

  render() {
    const isLogged = this.props.auth.isLogged;
    if (!isLogged) {
      this.props.history.push('/login');
      return ( null );
    }
    let isRegistrationComplete = false;
    let isVerified = false;
    if (this.props.auth.type === 'admin') {
      isVerified = true;
      isRegistrationComplete = true;
    } else if (this.props.auth.user) {      
      isVerified = this.props.auth.user.is_verified && this.props.auth.user.is_verified === true;   
      isRegistrationComplete = this.props.auth.user.desired_plan_id === null || 
                               this.props.auth.user.desired_plan_id === undefined || 
                               (this.props.auth.user.desired_plan_id.length === 0 && 
                                (this.props.auth.user.plan_queries > this.props.auth.user.used_queries || this.props.auth.user.plan_queries < 0) && 
                                !elapsed(this.props.auth.user.trial_expires_at)
                               );      
    }   
    const content = isVerified ? 
                      isRegistrationComplete ? 
                        this.renderDashboard() :
                        this.RegistrationIntegrationPanel()
                    : this.renderVerify() 
                    
    
    return (
      <div>
        {content}
      </div>
    )

  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  rehydrated: state.rehydrated
})

NavBar.contextType = LanguageContext;

export default withRouter(connect(mapStateToProps)(NavBar))
